import React, { useState, useEffect, useReducer } from 'react';
import './App.css'; 
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import DesktopApp from './Desktop';
import MobileApp from './Mobile';
import { Context, initialState } from './store/Context';
import { reducer } from './store/reducer';
import { auth } from './firebase';
import { onAuthStateChanged } from 'firebase/auth';

function App() {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 992); // Adjusted breakpoint for Desktop/Mobile split
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 992); // Use consistent breakpoint
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      dispatch({
        type: 'AUTH_STATE_CHANGE',
        value: {
          currentUser: user,
          loadingAuthState: false,
        },
      });
    });
    return () => unsubscribe();
  }, [dispatch]);

  // Simple loading state check
  if (state.loadingAuthState) {
       // return <div>Loading Authentication...</div>; // Or a proper spinner component
  }


  // Use a wrapper div with ID for potential scroll targets if needed outside main components
  return (
    <Context.Provider value={{ state, dispatch }}>
      <BrowserRouter>
         <div id="app-wrapper"> {/* Added wrapper */}
            {isDesktop ? (
              <Routes>
                <Route path="/" element={<DesktopApp />} />
                {/* Keep CharactersPage for now, can be integrated into Desktop/Mobile later */}
                {/* Add other routes like /login, /shop if needed */}
                {/* <Route path="/login" element={<LoginPage />} /> */}
                {/* <Route path="/shop" element={<ShopPage />} /> */}
                 {/* Add route for Contact page if it's separate */}
                 {/* <Route path="/contact" element={<ContactPage />} /> */}
              </Routes>
            ) : (
              <Routes>
                 <Route path="/" element={<MobileApp />} />
                 {/* Add corresponding mobile routes */}
                 {/* <Route path="/login" element={<LoginPage />} /> */}
                 {/* <Route path="/shop" element={<ShopPage />} /> */}
                 {/* <Route path="/contact" element={<ContactPage />} /> */}
              </Routes>
            )}
         </div>
      </BrowserRouter>
    </Context.Provider>
  );
}

export default App;